import { publicEnv } from '@/shared/config/publicEnv'
import { serverEnv } from '@/shared/config/serverEnv'
export type FeatureFlags = {
    _testPurpose: boolean
    hasSDDRepayments: boolean
    hasUserLimits: boolean
    hasRequirementsPortalLink: boolean
    hasProofs: boolean
}

export const parseBooleanEnvVar = (value: string | undefined): boolean => value === 'true'

export const parseListEnvVar = (value: string | undefined): string[] => value?.split(',').filter(Boolean) ?? []

export const getFeatureFlags = (): FeatureFlags => ({
    _testPurpose: parseBooleanEnvVar(serverEnv.testPurpose),
    hasSDDRepayments: parseBooleanEnvVar(publicEnv.hasSddRepayments),
    hasUserLimits: parseBooleanEnvVar(publicEnv.hasBeneficiaryLimits),
    hasRequirementsPortalLink: parseBooleanEnvVar(publicEnv.hasRequirementsPortalLink),
    hasProofs: parseBooleanEnvVar(publicEnv.hasProofs)
})
